'use strict';

var capPhoneConfiguration = require('./function');
const capencyHelper = require('core/capencyHelper');
const autocompleteUtil = require('./../utils/autocomplete');

/**
* Configures phone number fields for a given form based on the provided configuration.
*
* This function retrieves the phone field configuration for the specified form ID,
* sets up event listeners for phone number validation and formatting, and handles
* country-specific phone number processing.
*
* @param {string} formID - The ID of the form to configure phone fields for.
* @returns {boolean} - Always returns false to prevent default form submission behavior.
*/
function setConfigToCapPhone(formID) {
    // get config from de request Ajav for the currentForm
    var config = capPhoneConfiguration.getConfig(formID);

    if (config) {
        // events keyup keypress keydown for multiple NumberPhone for the form
        if (config.hasOwnProperty('phoneFieldsIDs')) {
            var phoneID = checkPhoneSelectorInfForms(formID, config.phoneFieldsIDs);
            config.idPhone = phoneID;
        }

        $('#' + config.idPhone).data('initValue', $(this).val() || '');

        // events keyup keypress keydown for NumberPhone
        $('#' + config.idPhone).on('change', function () {
            var value = $(this).val();
            if (value.length >= 1) {
                config.country = 'select[name$="_country"]';
                if ($(this).data('initValue').replace(/\s+/g, "") !== $(this).val().replace(/\s+/g, "")) {
                    capPhoneConfiguration.callProcessPhoneFlow(config);
                } else {
                    $(this).val($(this).data('initValue'));
                }
            }
        });

        $('#' + config.idPhone).on('blur', function () {
            let $this = $(this);
            if ($this.val().length === 0) {
                capencyHelper.setRequiredError($this);
            }
        });

        // events keyup accept only numbers
        $('#' + config.idPhone).keyup(function () {
            let $this = $(this);
            capencyHelper.removeFieldValidationResults($this);

            this.value = this.value.replace(/[^0-9]/g, '');
        });
        return false;
    }
}

/**
* Checks for the presence of phone selectors within a form and returns the ID of the first found selector.
*
* @param {string} formID - The ID of the form to search within.
* @param {Array<string>} selectors - An array of selector IDs to check for within the form.
* @returns {string} The ID of the first found selector, or an empty string if none are found.
*/
function checkPhoneSelectorInfForms(formID, selectors) {
    var currentSelectorID = '';
    $.each(selectors, function (i, id) {
        if ($('#' + formID).find('#' + id).length || $("form[name='" + formID + "']").find('#' + id).length) {
            currentSelectorID = id;
            return false;
        }
    });
    return currentSelectorID;
}

/**
* Disables browser autocomplete for all text input fields within a specified form.
*
* This function searches for a form by its ID or name and sets the `autocomplete` attribute
* of all text input fields within the form to "nop", effectively disabling browser autocomplete.
*
* @param {string} formID - The ID or name of the form for which to disable autocomplete.
*/
function deleteAutoCompleteBrowser(formID) {
    var $formSelector = $("form[id='" + formID + "']");

    if ($formSelector.length === 0) {
        $formSelector = $("form[name='" + formID + "']");
    }

    $formSelector.find('input[type=text]').each(function () {
        $(this).attr('autocomplete', autocompleteUtil.getAutocompleteValue());
    });
}

/**
* Removes duplicate elements from an array.
*
* This function filters out duplicate elements from the provided array, ensuring that each element appears only once.
*
* @param {Array} arr - The array from which duplicates need to be removed.
* @returns {Array} A new array with all duplicate elements removed.
*/
function removeDuplicates(arr) {
    return arr.filter((item,
        index) => arr.indexOf(item) === index);
}

module.exports = {
    initCapPhoneByForms: (formIdListToInit = []) => {
        var listFormWithCapAddress = capPhoneConfiguration.getIdForms();
        var formIDInBody = [];
        $('form').each(function () {
            var formID = (String($(this).attr('id')) === 'undefined' || typeof String($(this).attr('id')) === undefined) ? $(this).attr('name') : String($(this).attr('id'));
            if (formID && listFormWithCapAddress.includes(formID) && (formIdListToInit.length === 0 || formIdListToInit.includes(formID))) {
                formIDInBody.push(formID);
            }
        });

        var listFormsWithoutDuplicatesData = removeDuplicates(formIDInBody);
        $.each(listFormsWithoutDuplicatesData, function (index, form) {
            setConfigToCapPhone(form);
            deleteAutoCompleteBrowser(form);
        });
    }
};
